import React from 'react';
import { ShoppingCartSimple } from 'phosphor-react';
import { translate } from '../Services/translation';

const MiniCart = ({ productAdded, quantity, orderTotal, checkoutUrl, showInfo, toggle }) => (
    <div className={`cart cart--mini ${productAdded ? "product-added" : ""}`}>
        <a href={ checkoutUrl } className="cart__link--block">
            <span className="cart__icon-wrapper">
                <ShoppingCartSimple size={24} weight="regular" />
                {quantity > 0 && <span className="cart__quantity">{ quantity }</span>}
            </span>
            <span className="cart__title">{ translate('minicart.checkout') }</span>
        </a>
    </div>
)

export default MiniCart;